// Uses only the generated Visit response; never the legacy full-day depot totals.
export function durationSeconds(value) {
  if (typeof value !== "string") return null;
  const match = /^(?:(\d+)\.)?(\d+):(\d{2}):(\d{2})(?:\.(\d+))?$/.exec(value);
  if (!match || Number(match[3]) > 59 || Number(match[4]) > 59) return null;
  return Number(match[1] || 0) * 86400 + Number(match[2]) * 3600 + Number(match[3]) * 60 + Number(match[4]) + Number(`0.${match[5] || 0}`);
}

export function calculateVisitActivity(report) {
  const visits = report.visits || [];
  const trips = (report.trips || []).filter(trip => !trip.isSubTrip);
  const idling = visits.filter(visit => /virtual|idling/i.test(visit.visitType || ""));
  const parked = visits.filter(visit => !/virtual|idling/i.test(visit.visitType || ""));
  const open = parked.filter(visit => visit.isCurrent || visit.isOvernight || !visit.departed);
  const completed = parked.filter(visit => !visit.isCurrent && !visit.isOvernight && !!visit.departed);
  const classified = !!report.depot && completed.every(visit => typeof visit.isInDepot === "boolean");
  const outside = classified ? completed.filter(visit => !visit.isInDepot) : [];
  const depot = classified ? completed.filter(visit => visit.isInDepot) : [];
  const sum = rows => rows.reduce((total, row) => total + (durationSeconds(row.duration) || 0), 0);
  const outsideSeconds = sum(outside);
  const depotSeconds = sum(depot);
  const journeySeconds = trips.reduce((total, trip) => total + (durationSeconds(trip.journeyTime) || 0), 0);
  const durationsComplete = completed.every(visit => durationSeconds(visit.duration) !== null)
    && trips.every(trip => durationSeconds(trip.journeyTime) !== null);
  // Idling is already inside parent journey time; sub-trips overlap parent trips.
  const activitySeconds = journeySeconds + sum(completed);
  return {
    classified, durationsComplete, outsideCount: outside.length, depotCount: depot.length,
    completedCount: completed.length, openCount: open.length, idlingCount: idling.length,
    tripCount: trips.length, journeySeconds, outsideSeconds, depotSeconds, activitySeconds,
    outsideAverage: durationsComplete && outside.length ? outsideSeconds / outside.length : null,
    rate: classified && durationsComplete && activitySeconds > 0 ? outside.length * 3600 / activitySeconds : null,
  };
}

export function formatActivityTime(seconds) {
  if (seconds === null || !Number.isFinite(seconds)) return "—";
  const minutes = Math.round(seconds / 60);
  return minutes >= 60 ? `${Math.floor(minutes / 60)}h ${minutes % 60}m` : minutes === 0 && seconds > 0 ? "<1m" : `${minutes}m`;
}
